module.exports = "/shifts/components/shiftsExportOptions-4e479d.html";